import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import SsoLanding from "@/pages/SsoLanding";
import Inbox from "@/pages/Inbox";
import Templates from "@/pages/Templates";
import Broadcast from "@/pages/Broadcast";
import Contacts from "@/pages/Contacts";
import Products from "@/pages/Products";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";

const Protected = ({ children, adminOnly }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--cd-cream)" }}>
        <div className="font-hand text-2xl text-amber-900">loading your artboard...</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/inbox" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sso" element={<SsoLanding />} />
          <Route path="/" element={<Navigate to="/inbox" replace />} />
          <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
          <Route path="/templates" element={<Protected adminOnly><Templates /></Protected>} />
          <Route path="/broadcast" element={<Protected adminOnly><Broadcast /></Protected>} />
          <Route path="/contacts" element={<Protected adminOnly><Contacts /></Protected>} />
          <Route path="/products" element={<Protected adminOnly><Products /></Protected>} />
          <Route path="/dashboard" element={<Protected adminOnly><Dashboard /></Protected>} />
          <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
